import AllVouchers from "../../../srcMobile/components/Vouchers/AllVouchers";
import SavedVouchers from "../../../srcMobile/components/Vouchers/SavedVouchers";
// import ApprovedVouchers from "../../../srcMobile/components/Vouchers/ApprovedVouchers";
// import PendingApproval from "../../../srcMobile/components/Vouchers/PendingApproval";
// import RejectedVouchers from "../../../srcMobile/components/Vouchers/RejectedVouchers";
import { icons } from "../../assets/icons";

export const dashboardOptions = [
  {
    icon: icons.pettyCash,
    title: "Allocated Petty Cash",
    value: "₹ 25000",
    apiKey: "allocatedPettyCash",
  },
  {
    icon: icons.awaitingPayment,
    title: "Submitted Vouchers",
    value: "₹ 25000",
    showOptions: true,
    apiKey: "submittedVouchers",
    link: "/vouchers",
    cs: "cursor-pointer",
    tab: {
      id: 1,
      title: "View All Vouchers",
      Component: AllVouchers,
      showTo: ["Store", "L1", "L2", "L3", "Finance"],
    },
  },
  {
    icon: icons.notSubmitted,
    title: "Saved Vouchers",
    value: "₹ 25000",
    apiKey: "savedVouchers",
    link: "/vouchers",
    cs: "cursor-pointer",
    tab: {
      id: 5,
      title: "Saved Vouchers",
      Component: SavedVouchers,
      showTo: ["Store"],
    },
  },
  {
    icon: icons.availableCash,
    title: "Available Cash",
    value: "₹ 25000",
    apiKey: "availableCash",
  },
];

export const dashboardOptionsNonStore = [
  {
    icon: icons.dashboardTender,
    title: "Submitted Vouchers",
    showOptions: true,
    apiKey: "submittedVouchers",
    link: "/vouchers",
    cs: "cursor-pointer",
    tab: {
      id: 1,
      title: "View All Vouchers",
      Component: AllVouchers,
      showTo: ["Store", "L1", "L2", "L3", "Finance"],
    },
  },
  {
    icon: icons.awaitingPayment,
    title: "Pending For Approval",
    apiKey: "pendingForApproval",
    link: "/vouchers",
    cs: "cursor-pointer",
    tab: {
      id: 3,
      title: "Vouchers Pending Approval",
      // Component: PendingApproval,
      showTo: ["Store", "L1", "L2", "L3", "Finance"],
    },
  },
  {
    icon: icons.dashboardApproved,
    title: "Approved",
    apiKey: "approved",
    link: "/vouchers",
    cs: "cursor-pointer",
    tab: {
      id: 2,
      title: "Voucher Approved",
      // Component: ApprovedVouchers,
      showTo: ["Store", "L1", "L2", "L3", "Finance"],
    },
  },
  {
    icon: icons.dashboardRejected,
    title: "Rejected",
    apiKey: "rejected",
    link: "/vouchers",
    cs: "cursor-pointer",
    tab: {
      id: 4,
      title: "Vouchers Rejected",
      // Component: RejectedVouchers,
      showTo: ["Store", "L1", "L2", "L3", "Finance"],
    },
  },
];
